export const GET_PHARMACIES_LIST = 'pharmacies/GET_PHARMACIES_LIST';

export function getPharmacies({search, offset = 0, state}) {
    return {
        type: GET_PHARMACIES_LIST,
        httpRequest: {
            path: '/pharmacies',
            method: 'get',
            params: {
                search,
                state,
                offset,
            },
        },
    };
}



// WEBPACK FOOTER //
// ./src/reducers/pharmacies/pharmaciesActions.js